import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";
import { GetOrderListFilters } from "../model/GetOrderListFilters";
import { OrderListItem } from "../model/OrderListSuccessResponse";

const emptyOrderList: OrderListItem[] = [];
Object.freeze(emptyOrderList);

export const orders = (
  state: RootState,
  filters: GetOrderListFilters,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return (
    state.shop.org[org]?.orderList[JSON.stringify(filters)] || emptyOrderList
  );
};

export const isLoadingOrderList = (
  state: RootState,
  filters: GetOrderListFilters,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.orderListIsLoading;
};

export const order = (
  state: RootState,
  id: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.order[id];
};

export const isLoadingOrder = (
  state: RootState,
  id: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.orderIsLoading[id];
};
